// Copyright 2017 Rigo Investment Sagl.
// This file is part of RigoBlock.

import DragoEventfulParity from './Parity/dragoEventful'
import DragoEventfulWeb3 from './Web3/dragoEventful'
import DragoFactoryParity from './Parity/dragoFactory'
import DragoFactoryWeb3 from './Web3/dragoFactory'
import DragoParity from './Parity/drago'
import DragoRegistryParity from './Parity/dragoRegistry'
import DragoRegistryWeb3 from './Web3/dragoRegistry'
import DragoWeb3 from './Web3/drago'
import EtherParity from './Parity/ether'
import EtherWeb3 from './Web3/ether'
import EthusdParity from './Parity/ethusd'
import FundProxyWeb3 from './Web3/fundProxy'
// import FundProxyParity from './Parity/fundProxy'
import { isMetamask } from './../utils/utils'
import ExchangeParity from './Parity/exchange'
import RegistryParity from './registry'
import RigoTokenFaucetParity from './Parity/rigoTokenFaucet'
import RigoTokenFaucetWeb3 from './Web3/rigoTokenFaucet'
import RigoTokenParity from './Parity/rigoToken'
import RigoTokenWeb3 from './Web3/rigoToken'
import TokenWrapperParity from './Parity/tokenWrapper'
import TokenWrapperWeb3 from './Web3/tokenWrapper'
import VaultEventfulParity from './Parity/vaultEventful'
import VaultEventfulWeb3 from './Web3/vaultEventful'
import VaultFactoryParity from './Parity/vaultFactory'
import VaultFactoryWeb3 from './Web3/vaultFactory'
import VaultParity from './Parity/vault'
import VaultWeb3 from './Web3/vault'

class Contract {
  constructor(api) {
    if (!api) {
      throw new Error('API instance needs to be provided to Contract')
    }
    if (isMetamask(api)) {
      this._drago = new DragoWeb3(api)
      this._dragoeventful = new DragoEventfulWeb3(api)
      this._dragofactory = new DragoFactoryWeb3(api)
      this._dragoregistry = new DragoRegistryWeb3(api)
      this._ether = new EtherWeb3(api)
      this._vault = new VaultWeb3(api)
      this._vaulteventful = new VaultEventfulWeb3(api)
      this._vaultfactory = new VaultFactoryWeb3(api)
      this._rigotoken = new RigoTokenWeb3(api)
      this._rigotokenfaucet = new RigoTokenFaucetWeb3(api)
      this._tokenwrapper = new TokenWrapperWeb3(api)
      this._fundproxy = new FundProxyWeb3(api)
    } else {
      this._drago = new DragoParity(api)
      this._dragoeventful = new DragoEventfulParity(api)
      this._dragofactory = new DragoFactoryParity(api)
      this._dragoregistry = new DragoRegistryParity(api)
      this._ethusd = new EthusdParity(api)
      this._ether = new EtherParity(api)
      this._exchange = new ExchangeParity(api)
      this._registry = new RegistryParity(api)
      this._rigotoken = new RigoTokenParity(api)
      this._rigotokenfaucet = new RigoTokenFaucetParity(api)
      this._tokenwrapper = new TokenWrapperParity(api)
      // this._fundproxy = new RigoTokenParity(api)
      this._vault = new VaultParity(api)
      this._vaulteventful = new VaultEventfulParity(api)
      this._vaultfactory = new VaultFactoryParity(api)
    }
  }

  get dragoregistry() {
    return this._dragoregistry
  }

  get drago() {
    return this._drago
  }

  get dragofactory() {
    return this._dragofactory
  }

  get ethusd() {
    return this._ethusd
  }

  get dragoeventful() {
    return this._dragoeventful
    // return typeof this._dragoeventful !== 'undefined'
    //   ? this._dragoeventful
    //   : this._dragoeventful
  }

  get vaulteventful() {
    return this._vaulteventful
    // return typeof this._vaulteventful !== 'undefined'
    //   ? this._vaulteventful
    //   : this._vaulteventful
  }

  get ether() {
    return this._ether
  }

  get exchange() {
    return this._exchange
  }

  get fundproxy() {
    return this._fundproxy
  }

  get registry() {
    return this._registry
  }

  get rigotoken() {
    return this._rigotoken
  }

  get rigotokenfaucet() {
    return this._rigotokenfaucet
  }

  get tokenwrapper() {
    return this._tokenwrapper
  }

  get vaultfactory() {
    return this._vaultfactory
  }

  get vault() {
    return this._vault
  }
}

export default Contract
